// https://regex101.com/r/ZKFfzC/3
import { getDemoUsernames } from '~/src/dash/resellers/utils/importResellerConfig';
import { DemandSources } from '~/src/dash/globals/demand-sources';
import {
  FirstAndThirdPartyDashboardCardDataCompareKeys,
  FirstAndThirdPartyDashboardCardDataKeys,
  FirstAndThirdPartyDashboardCardDataTitles,
  IFirstAndThirdPartyDashboardCardDataDisplayItem,
} from '~/src/dash/views/measurement-home-view';
import {
  StreamDashboardCardDataCompareKeys,
  StreamDashboardCardDataKeys,
  StreamDashboardCardDataTitles,
} from '~/src/dash/views/networks/constants';

export const REGEX_EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const REGEX_NUMERIC = /^[0-9]*$/;

export function onlyNumeric(s: string): boolean {
  return !!s && REGEX_NUMERIC.test(s);
}

export const DEMO_ACCOUNTS = getDemoUsernames();

export const APS_BIDDERS = [
  DemandSources.apsOpenAuction,
  DemandSources.apsPMP,
  DemandSources.apsGuarantee,
];
{
  /*  hide the toggle Podded Requests for Xandr aka appnexus (un-hide in q1 when xandr is compliant with 2.6.) */
}
export const BIDDERS_PODDED_REQUEST_ENABLED = [
  DemandSources.amazonORTB,
  DemandSources.appnexus,
  DemandSources.beachfront,
  DemandSources.column6,
  DemandSources.connatix,
  DemandSources.criteo,
  DemandSources.dynamicGateway,
  DemandSources.dynamicPlatformConnection,
  DemandSources.elementaltv,
  DemandSources.finecast,
  DemandSources.freewheelssp,
  DemandSources.gateway,
  DemandSources.gatewayTier0,
  DemandSources.improvedigital,
  DemandSources.indexExchange,
  DemandSources.inmobi,
  DemandSources.magnitectv,
  DemandSources.mobilefuse,
  DemandSources.nexstar,
  DemandSources.openx,
  DemandSources.platformConnection,
  DemandSources.premion,
  DemandSources.pubmatic,
  DemandSources.publica,
  DemandSources.rhythmone,
  DemandSources.sabio,
  DemandSources.samsungAdManager,
  DemandSources.samsungDSP,
  DemandSources.samsungssp,
  DemandSources.samsungssptest,
  DemandSources.sharethrough,
  DemandSources.smaato,
  DemandSources.smartadserver,
  DemandSources.smartclip,
  DemandSources.smartstream,
  DemandSources.sovrn,
  DemandSources.stroer,
  DemandSources.tappx,
  DemandSources.teads,
  DemandSources.thetradedesk,
  DemandSources.triplelift,
  DemandSources.vibe,
  DemandSources.videoHeroesRevShare,
  DemandSources.videoHeroesFixedCPM,
  DemandSources.videobyte,
  DemandSources.vrtcal,
  DemandSources.wurl,
];

export const ORTB26_ENABLED_BIDDERS = [
  DemandSources.amazonORTB,
  DemandSources.appnexus,
  DemandSources.column6,
  DemandSources.connatix,
  DemandSources.criteo,
  DemandSources.elementaltv,
  DemandSources.finecast,
  DemandSources.freewheelssp,
  DemandSources.improvedigital,
  DemandSources.indexExchange,
  DemandSources.inmobi,
  DemandSources.marketingarchitects,
  DemandSources.mobilefuse,
  DemandSources.nexstar,
  DemandSources.openx,
  DemandSources.premion,
  DemandSources.pubmatic,
  DemandSources.rhythmone,
  DemandSources.sabio,
  DemandSources.samsungAdManager,
  DemandSources.sharethrough,
  DemandSources.smaato,
  DemandSources.smartclip,
  DemandSources.smartstream,
  DemandSources.sovrn,
  DemandSources.stroer,
  DemandSources.tappx,
  DemandSources.teads,
  DemandSources.thetradedesk,
  DemandSources.triplelift,
  DemandSources.undertone,
  DemandSources.vibe,
  DemandSources.videobyte,
  DemandSources.vrtcal,
  DemandSources.wurl,
] as string[];

export const ORTB26_ENABLED_PODDED_TYPE_DYNAMIC_BIDDERS = [
  DemandSources.amazonORTB,
  DemandSources.appnexus,
  DemandSources.column6,
  DemandSources.connatix,
  DemandSources.criteo,
  DemandSources.elementaltv,
  DemandSources.finecast,
  DemandSources.freewheelssp,
  DemandSources.improvedigital,
  DemandSources.indexExchange,
  DemandSources.inmobi,
  DemandSources.mobilefuse,
  DemandSources.nexstar,
  DemandSources.openx,
  DemandSources.pubmatic,
  DemandSources.rhythmone,
  DemandSources.sabio,
  DemandSources.samsungAdManager,
  DemandSources.smaato,
  DemandSources.smartclip,
  DemandSources.sovrn,
  DemandSources.stroer,
  DemandSources.tappx,
  DemandSources.teads,
  DemandSources.thetradedesk,
  DemandSources.triplelift,
  DemandSources.videobyte,
  DemandSources.vrtcal,
  DemandSources.wurl,
] as string[];

export const ORTB26_ENABLED_PODDED_TYPE_STRUCTURED_BIDDERS = [
  DemandSources.amazonORTB,
  DemandSources.appnexus,
  DemandSources.connatix,
  DemandSources.criteo,
  DemandSources.elementaltv,
  DemandSources.finecast,
  DemandSources.freewheelssp,
  DemandSources.improvedigital,
  DemandSources.indexExchange,
  DemandSources.inmobi,
  DemandSources.mobilefuse,
  DemandSources.openx,
  DemandSources.premion,
  DemandSources.pubmatic,
  DemandSources.rhythmone,
  DemandSources.sabio,
  DemandSources.samsungAdManager,
  DemandSources.sharethrough,
  DemandSources.smartstream,
  DemandSources.sovrn,
  DemandSources.tappx,
  DemandSources.teads,
  DemandSources.thetradedesk,
  DemandSources.triplelift,
  DemandSources.vibe,
  DemandSources.vrtcal,
  DemandSources.videobyte,
] as string[];

export const ORTB26_ENABLED_PODDED_TYPE_HYBRID_BIDDERS = [
  DemandSources.connatix,
  DemandSources.inmobi,
  DemandSources.pubmatic,
  DemandSources.rhythmone,
  DemandSources.samsungAdManager,
  DemandSources.sovrn,
  DemandSources.tappx,
  DemandSources.vrtcal,
  DemandSources.teads,
] as string[];

export const BIDDERS_MULTI_BID_ENABLED = [
  DemandSources.magnitectv,
  DemandSources.verizon, // for yahoo demand source in dropdown
];

export const BIDDERS_ADBREAK_TARGETING_ENABLED = [DemandSources.publica];

export const BIDDERS_WITHOUT_BID_ADJUSTMENT_FACTOR = [
  DemandSources.samsungssptest,
  DemandSources.samsungssp,
];

export const ALL_PLATFORM_CONNECTION_BIDDERS = [
  DemandSources.dynamicGateway,
  DemandSources.dynamicPlatformConnection,
  DemandSources.gateway,
  DemandSources.gatewayTier0,
  DemandSources.platformConnection,
  DemandSources.videoHeroesRevShare,
  DemandSources.videoHeroesFixedCPM,
];

export const FIXED_PRICE_PLATFORM_CONNECTION_BIDDERS = [
  DemandSources.gateway,
  DemandSources.gatewayTier0,
  DemandSources.platformConnection,
  DemandSources.videoHeroesFixedCPM,
];

export const DYNAMIC_PLATFORM_CONNECTION_BIDDERS = [
  DemandSources.dynamicGateway,
  DemandSources.dynamicPlatformConnection,
  DemandSources.videoHeroesRevShare,
];

export const BIDDERS_SHARE_OF_VOICE_TYPE_ENABLED = [
  DemandSources.dynamicGateway,
  DemandSources.dynamicPlatformConnection,
  DemandSources.gateway,
  DemandSources.gatewayTier0,
  DemandSources.platformConnection,
  DemandSources.publica,
  DemandSources.videoHeroesRevShare,
  DemandSources.videoHeroesFixedCPM,
];

// update DisabledSecondaryRequestBidders in platform with this array
export const NO_SECONDARY_REQUEST_BIDDERS = [
  DemandSources.apsGuarantee,
  DemandSources.apsPMP,
  DemandSources.apsOpenAuction,
  DemandSources.dynamicGateway,
  DemandSources.dynamicPlatformConnection,
  DemandSources.freewheel,
  DemandSources.gateway,
  DemandSources.gatewayTier0,
  DemandSources.platformConnection,
  DemandSources.publicaCampaign,
  DemandSources.publica,
  DemandSources.rokuHB,
  DemandSources.samsungssp,
];

// ---------------------- Home dashboard -----------------------------

export type HomeDashboardCardDataTitles =
  | 'Revenue'
  | 'Impressions'
  | 'CPM'
  | 'Endpoint Requests'
  | 'Render Rate'
  | 'Pod Fill Rate'
  | 'CPM Per Second'
  | 'Auctions'
  | 'Fill Rate'
  | 'Bid Requests'
  | 'Bid Responses'
  | 'Winning Bids'
  | 'Bid Response Rate'
  | 'Bid Timeout Rate'
  | 'Pod Clear Rate'
  | 'Paid Pod Clear Rate'
  | 'Endpoint Request eCPM';

export type IHomeDashboardCardDataDisplay = Record<
  HomeDashboardCardDataTitles,
  IHomeDashboardCardDataDisplayItem
>;

interface IHomeDashboardCardDataDisplayItem {
  value: string;
  sign: number;
}

// ---------------------- Network dashboard -----------------------------

// ---------------------- Measurement Dashboard -----------------------------
export type IMeasurementAggregateCardDataDisplay = Record<
  FirstAndThirdPartyDashboardCardDataTitles,
  IFirstAndThirdPartyDashboardCardDataDisplayItem
>;

// ---------------------- Dashboard Unions -----------------------------
export interface ISelectedMetric {
  key: DashboardCardDataTitles;
  active: boolean;
}
export type DashboardCardDataTitles =
  | StreamDashboardCardDataTitles
  | FirstAndThirdPartyDashboardCardDataTitles
  | HomeDashboardCardDataTitles;
export type DashboardCardDataKeys =
  | StreamDashboardCardDataKeys
  | FirstAndThirdPartyDashboardCardDataKeys;
export type DashboardCardDataCompareKeys =
  | StreamDashboardCardDataCompareKeys
  | FirstAndThirdPartyDashboardCardDataCompareKeys;

// ---------------------- Misc -----------------------------
export const CreativeTypeMediafile: string = 'mediafile';
export const CreativeTypeVast: string = 'vast';
export const WeightingTypeRequests: string = 'Requests count';
export const WeightingTypeImps: string = 'Imps count';

// ---------------------- Live Data ------------------------
export const DensityRangeHourByHour = 1;
export const DensityRange15Minutes = 15;
export const DensityRange30Minutes = 30;
export const DensityRange1HourByMinutes = 60;
export const DensityRange4HoursByHour = 4;
export const DensityRange4HoursByMinutes = 240;
export const DensityRange6HoursByMinutes = 360;
export const DensityRange12HoursByHour = 12;
export const DensityRange12HoursByMinutes = 720;
export const DensityRange24HoursByHour = 24;
export const DensityRange24HoursByMinutes = 1440;
export const DensityRangeWeekByHour = 168;

export interface IDensityRange {
  text: string;
  value: number;
}
